import {
  Directive,
  EventEmitter,
  HostBinding,
  HostListener,
  Output
} from '@angular/core';

@Directive({
  selector: '[appDragDrop]',
  standalone: false
})
export class DragDropDirective {
  @Output() readonly onFileDropped = new EventEmitter<any>();

  @HostBinding('style.background-color') public background = '#f5fcff';
  @HostBinding('style.opacity') public opacity = '1';

  // Dragover listener
  @HostListener('dragover', ['$event']) onDragOver(evt) {
    evt.preventDefault(); // NOSONAR
    evt.stopPropagation(); // NOSONAR
    this.background = '#9ecbec';
    this.opacity = '0.8';
  }

  // Dragleave listener
  @HostListener('dragleave', ['$event'])
  public onDragLeave(evt) {
    evt.preventDefault(); // NOSONAR
    evt.stopPropagation(); // NOSONAR
    this.background = '#f5fcff';
    this.opacity = '1';
  }

  // Drop listener
  @HostListener('drop', ['$event'])
  public ondrop(evt) {
    evt.preventDefault(); // NOSONAR
    evt.stopPropagation(); // NOSONAR
    this.background = '#f5fcff';
    this.opacity = '1';
    const {files} = evt.dataTransfer;
    if (files.length > 0) {
      this.onFileDropped.emit(files);
    }
  }
}
